<template>
  <div>
    <component
      v-for="item in childList"
      v-bind:key="item.typeName + item.id"
      v-bind:id="item.typeName + item.id"
      v-bind:is="item.typeName"
      v-show="!(item.isDontSave && $store.getters.editMode)"
      v-bind="item.attrList"
      v-bind:properties="properties"
      v-bind:events="events"
      :ident="item.typeName + item.id"
      @mousedown.stop="onClickComponent(ident + item.typeName + item.id, item.typeName)"
    >
    </component>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import MixinBase from "./mixin-base.js";
import pipeline_horizontal from "./pipeline_horizontal.vue";
import pipeline_vertical from "./pipeline_vertical.vue";
import pipeline_90_rightbottom from "./pipeline_90_rightbottom.vue";
import pipeline_90_rightup from "./pipeline_90_rightup.vue";
import pipeline_90_leftbottom from "./pipeline_90_leftbottom.vue";
import pipeline_90_leftup from "./pipeline_90_leftup.vue";
import indicator from "./indicator.vue";
import drawing from "./drawing.vue";
import icon from "./icon.vue";
import heading from "./heading.vue";
import valve from "./valve.vue";
import cool_pump from "./cool_pump.vue";
import state_interpreter from "./state_interpreter.vue";
import progressbar from "./progressbar.vue";
import button_ from "./button_.vue";
import editor from "./editor.vue";
import input_ from "./input_.vue";
import dropdown_ from "./dropdown_.vue";
import pipeline_cross from "./pipeline_cross.vue";
import scnd from "./scnd.vue";
import submersibl_pump from "./submersibl_pump.vue";
import vert_pump from "./vert_pump.vue";
import tank from "./tank.vue";
import tank_double_level from "./tank_double_level.vue";
import line_ from "./line_.vue";
import sign from "./sign.vue";

import MixinContainer from "./mixin-container.js";

//import panel                     from './panel.vue'

import EventBus from "@/core/EventBus";
export default {
  name: "container-base",
  mixins: [MixinBase, MixinContainer],
  components: {
    pipeline_horizontal,
    pipeline_vertical,
    pipeline_90_rightbottom,
    pipeline_90_rightup,
    pipeline_90_leftbottom,
    pipeline_90_leftup,
    indicator,
    drawing,
    heading,
    valve,
    cool_pump,
    state_interpreter,
    icon,
    progressbar,
    button_,
    editor,
    input_,
    dropdown_,
    pipeline_cross,
    scnd,
    submersibl_pump,
    vert_pump,
    tank,
    tank_double_level,
    line_,
    sign,
    panel: defineAsyncComponent(() => import("./panel.vue")),
  },
  mounted() {
    this.eventHandlerContainer();
    EventBus.on("on-target-component", (elem) => {
      setTimeout(() => this.onClickComponent(elem.typeName + elem.id, elem.typeName), 10);
    });
    EventBus.on("on-event-hundler-container", () => this.eventHandlerContainer());
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.eventHandlerContainer);
    EventBus.off("on-target-component");
    EventBus.off("on-event-hundler-container");
  },
  created() {
    window.addEventListener("resize", this.eventHandlerContainer);
  },
  methods: {
    onClickComponent(id, typeName) {
      const elementGuidelines = [];
      //let URI, round, heading_caption, fill, src;
      let attrList;
      for (const item of this.childList) {
        if (item.typeName + item.id !== id && item.typeName === typeName) {
          elementGuidelines.push(document.getElementById(item.typeName + item.id)); //
        }

        if (item.typeName + item.id === id) {
          attrList = { ...item.attrList };
        }
      }
      EventBus.emit("on-click-component", {
        id: id,
        elementGuidelines: elementGuidelines,
        attrList: attrList,
        /*URI: URI,
        round: round,
        heading_caption: heading_caption,
        fill: fill,
        src: src,*/
      });
    },
    eventHandlerContainer() {
      let left = this.$store.getters.showFacilitiesMenu ? 8.5 : 0;
      if (document.documentElement.clientWidth < 1332) {
        this.$el.style.left = left ? `114px` : `0px`; //TODO: из за .restriction-struct-list   min-width: 130px;
        return;
      }
      if (document.documentElement.clientWidth > 2122) {
        const addition = left * (1 - 2122 / document.documentElement.clientWidth);
        left = left - addition;
      }
      this.$el.style.left = `${Math.round(
        document.documentElement.clientWidth * (left / 100)
      )}px`;
    },
  },
};
</script>
